module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-ExtraBold.1a8a3765.woff2";